package org.matthewo.components

import emotion.react.css
import org.matthewo.styles.BACKGROUND_COLOR
import org.matthewo.styles.FONT_COLOR
import org.matthewo.styles.TITLE_FONT_COLOR
import react.FC
import react.PropsWithChildren
import react.PropsWithClassName
import react.dom.html.ReactHTML.dialog
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useRef
import web.cssom.*
import web.dom.ElementId
import web.html.HTMLDialogElement

external interface ModalProps : PropsWithChildren, PropsWithClassName {
    var open: Boolean
    var onClose: () -> Unit
    // the element that names the modal, for screen readers
    var labelledBy: ElementId?
}

/**
 * A dialog over the page, which closes with escape or a click outside it.
 */
val Modal = FC<ModalProps>("Modal") { props ->
    val dialogRef = useRef<HTMLDialogElement>()

    useEffect(props.open) {
        val dialog = dialogRef.current ?: return@useEffect
        if (props.open && !dialog.open) dialog.showModal()
        else if (!props.open && dialog.open) dialog.close()
    }

    dialog {
        ref = dialogRef
        ariaLabelledBy = props.labelledBy

        css {
            border = Border(2.px, LineStyle.solid, TITLE_FONT_COLOR)
            borderRadius = 0.5.em
            // the content has the padding, so a click on the dialog itself is outside it
            padding = 0.px
            maxWidth = min(24.em, 100.vw - 2.em)

            backgroundColor = BACKGROUND_COLOR
            color = FONT_COLOR

            backdrop {
                backgroundColor = rgb(0, 0, 0, 0.5)
                backdropFilter = blur(4.px)
            }
        }

        onClose = { props.onClose() }
        onClick = { if (it.target == it.currentTarget) props.onClose() }

        div {
            css(props.className) {
                padding = 1.5.em
            }
            +props.children
        }
    }
}
